import { v4 as uuid } from 'uuid';
import { epoch, utc } from '../../util/datetime';
import { sanitizeHtml, toUUID } from '../../util/transform';
import type { ITicketStatusHistory } from './TicketStatusHistory.interface';

export default class TicketStatusHistory implements ITicketStatusHistory {
  id: string;
  idOwner: string;
  isDueAhead: boolean;
  isDue: boolean;
  isOverdue: boolean;
  isInProgress: boolean;
  isReadyForVerification: boolean;
  isVerified: boolean;
  isFrozen: boolean;
  isRotten: boolean;
  isSubmitted: boolean;
  isLodged: boolean;
  isConditionallyApproved: boolean;
  isApproved: boolean;
  isSettled: boolean;
  isWon: boolean;
  isWithDrawn: boolean;
  isDeclined: boolean;
  isLost: boolean;
  isActive: boolean;
  note: string;
  timeStampSet: number;
  timeStamp: number;

  setTimeStamp() {
    this.timeStampSet = this.timeStamp;
    this.timeStamp = epoch(utc());
  }

  static build = (data: ITicketStatusHistory) => new TicketStatusHistory(data);
  static blank = () =>
    new TicketStatusHistory({
      id: uuid(),
      timeStampSet: 0,
      timeStamp: epoch(utc()),
      isActive: true
    });

  /**
   * Constructor
   * @param {ITicketStatusHistory} data
   */
  constructor(data?: ITicketStatusHistory) {
    this.id = toUUID(data?.id) || uuid();
    this.idOwner = toUUID(data?.idOwner);
    this.isDueAhead = data?.isDueAhead === true;
    this.isDue = data?.isDue === true;
    this.isOverdue = data?.isOverdue === true;
    this.isInProgress = data?.isInProgress === true;
    this.isReadyForVerification = data?.isReadyForVerification === true;
    this.isVerified = data?.isVerified === true;
    this.isFrozen = data?.isFrozen === true;
    this.isRotten = data?.isRotten === true;
    this.isSubmitted = data?.isSubmitted === true;
    this.isLodged = data?.isLodged === true;
    this.isConditionallyApproved = data?.isConditionallyApproved === true;
    this.isApproved = data?.isApproved === true;
    this.isSettled = data?.isSettled === true;
    this.isWon = data?.isWon === true;
    this.isWithDrawn = data?.isWithDrawn === true;
    this.isDeclined = data?.isDeclined === true;
    this.isLost = data?.isLost === true;
    this.isActive = data?.isActive !== false;
    this.note = sanitizeHtml(data?.note || '');
    this.timeStampSet = data?.timeStampSet ? epoch(utc(data?.timeStampSet)) : 0;
    this.timeStamp = epoch(utc(data?.timeStamp));
  }
}
